import React from "react"
import Chip from "material-ui/Chip"
import strings from "../../localization/strings"
import AddPositionDialog from "./AddPositionDialog"
import { IPosition } from "../../models"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    position: IPosition
    usablePositionLabel: string
    // for example, if add the job position, it's client's positions 
    usablePositions: IPosition[]
    onRequestSave(position: IPosition): void
}
interface IState {
    openAddPositionDialog: boolean
}

export default class PositionSelectChip extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddPositionDialog: false
        }
    }

    render() {
        const positionName = this.props.position && this.props.position.Name
        return (
            <div>
                <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.3)" }}>
                    {checkPositionFieldAvailable('singular') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel : strings.Position}
                </div>
                <Chip
                    data-intercom-target={checkPositionFieldAvailable('singular') ? `Select-${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : "Select-Position"}
                    style={{ cursor: "pointer", margin: 2, height: 35, width: "min-content" }}
                    onClick={() => this.setState({ openAddPositionDialog: true })}
                    onRequestDelete={this.props.position ? () => this.props.onRequestSave(null) : null}
                >
                    <div
                        className="TextOverflow"
                        style={{ maxWidth: 250, minWidth: 100 }}
                        title={positionName}
                    >
                        {positionName ?
                            positionName :
                            checkPositionFieldAvailable('singular') ?
                                `Select ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}...` :
                                `${strings.Select_Position}...`
                        }
                    </div>
                </Chip>
                {this.state.openAddPositionDialog &&
                    <AddPositionDialog
                        ignoreDates
                        editPosition={this.props.position}
                        usablePositionLabel={this.props.usablePositionLabel}
                        usablePositions={this.props.usablePositions}
                        existPositions={[]}
                        onRequestClose={() => this.setState({ openAddPositionDialog: false })}
                        onRequestSave={this.props.onRequestSave}
                    />
                }
            </div >
        )
    }
}